import GridCard from "@/components/census/GridCard";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Component, Mixins, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import GridCardIcu from "./census/GridCardIcu";
import GridCardOb from "./census/GridCardOb";
import GridCardPacu from "./census/GridCardPacu";
import AddPatient from "./census/mixins/AddPatient";

@Component({
  components: { GridCard, GridCardOb, GridCardIcu, GridCardPacu }
})
export default class CensusGrid extends Mixins(AddPatient) {
  @Getter("config", patientNamespace)
  config!: any;

  @Prop(Array)
  patients!: Array<Patient>;

  @Prop(String)
  area!: string;

  // TODO: Put in sub-component?
  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  getColor(caseStateIndex: number) {
    const caseStates = this.$store.getters["patient/caseState"];
    if (caseStates && caseStates[caseStateIndex]) {
      return caseStates[caseStateIndex].color;
    }
    return null;
  }

  get census() {
    return this.patients
      .filter(this.config.census.grid.filterFunction)
      .map((p: Patient) => p.census);
  }
}
